import amplitude from 'amplitude-js';
import Config from 'react-native-config';

import {
  AnalyticsEvent,
  AnalyticsUserStat,
  AmplitudeProviderType,
  AS
} from './AnalyticsService.common';

// interfaces must be imported from a file with only types/interfaces in it
import {
  AnalyticsUserAttributes,
  AnalyticsUserStats,
  AmplitudeEventData
} from './AnalyticsService.interfaces';

export {
  AnalyticsEvent, // enum
  AnalyticsUserStat, // enum
  AmplitudeProviderType, // enum
  AnalyticsUserAttributes, // interface
  AnalyticsUserStats, // interface
  AmplitudeEventData // interface
};

// This is only returns values for mobile (and even then only for Android).
const getAppInstallDate = () => {
  return null;
};

const configOptions = {
  useNativeDeviceInfo: true,
  includeReferrer: true,
  includeUtm: true,
  includeGclid: true,
  saveParamsReferrerOncePerSession: false
};

// getAppInstallDate is used inside the AS class, and for mobile it requires an import
// that is incompatible with React/web (DeviceInfo from 'react-native-device-info')
// so the AS class constructor has been refactored to take getAppInstallDate as a parameter...
const analyticsService = new AS(
  Config.AMPLITUDE_API_KEY,
  amplitude,
  configOptions,
  getAppInstallDate
);

export const CDP_ID_KEY = 'CDP_ID';
export default analyticsService;

export * from './AnalyticsService.common';
